/**
 * Nguyên văn chính sách app thành viên đang phát hành.
 *
 * Lấy từ `GET /policies/current` trên staging — cùng bản màn chính sách trong app đọc.
 * Trang công khai nhúng sẵn để vẫn đọc được khi không gọi được API.
 */
export const memberPrivacyPolicy = {
  code: '2026.08',
  title: 'CHÍNH SÁCH BẢO VỆ THÔNG TIN KHÁCH HÀNG',
  effectiveFrom: '2026-09-03T02:43:17.666229+00:00',
  content: `1. Cam kết bảo mật thông tin
Công ty cam kết bảo mật và bảo vệ thông tin cá nhân của khách hàng, đồng thời thực hiện việc thu thập, lưu trữ, sử dụng và xử lý dữ liệu cá nhân phù hợp với quy định pháp luật Việt Nam hiện hành.

2. Thông tin được thu thập và mục đích sử dụng
Tùy theo dịch vụ khách hàng sử dụng, Công ty có thể thu thập các thông tin như: họ tên, số điện thoại, email, thông tin đặt bàn, lịch sử giao dịch và các thông tin cần thiết khác.

Thông tin khách hàng được sử dụng nhằm:
• Xác minh và quản lý thông tin khách hàng.
• Hỗ trợ đặt bàn và cung cấp sản phẩm, dịch vụ.
• Chăm sóc khách hàng và hỗ trợ giải đáp các yêu cầu, phản hồi hoặc khiếu nại.
• Cung cấp thông tin về chương trình ưu đãi, khuyến mãi, sản phẩm và dịch vụ mới.
• Cải thiện chất lượng sản phẩm, dịch vụ và trải nghiệm khách hàng.
• Thực hiện các mục đích khác phù hợp với quy định pháp luật và sự đồng ý của khách hàng khi cần thiết.

3. Bảo mật và chia sẻ thông tin
Công ty áp dụng các biện pháp phù hợp để bảo vệ thông tin cá nhân của khách hàng, hạn chế việc truy cập, sử dụng hoặc tiết lộ thông tin trái phép.

Thông tin cá nhân của khách hàng không được cung cấp cho bên thứ ba, trừ trường hợp khách hàng đồng ý hoặc việc cung cấp thông tin là cần thiết để thực hiện dịch vụ, hoặc được yêu cầu, cho phép theo quy định pháp luật và/hoặc theo yêu cầu của cơ quan nhà nước có thẩm quyền.

4. Quyền của khách hàng
Khách hàng có quyền yêu cầu được biết, cập nhật, điều chỉnh hoặc thực hiện các quyền khác đối với dữ liệu cá nhân của mình theo quy định pháp luật hiện hành.

Đối với các yêu cầu liên quan đến thông tin cá nhân, khách hàng có thể liên hệ Công ty TNHH 4M F&B hoặc Bộ phận Chăm sóc Khách hàng của thương hiệu mà khách hàng đang sử dụng dịch vụ để được hỗ trợ.

5. Thông tin liên hệ
CÔNG TY TNHH 4M F&B
Mã số doanh nghiệp: 0317806688
Địa chỉ: Tòa nhà M-Building, số 09 Đường số 08, Khu A, Đô Thị Mới Nam Thành Phố, Phường Tân Mỹ, Thành phố Hồ Chí Minh, Việt Nam.`,
} as const;
